<style>
  #MainDivCat *{
    font-weight: bolder;
    font-size: 14px;
    list-style: none;
  }
</style>

<div id="MainDivCat">
  <ul>
    <li class="MyMoeinListCat_Li">

      <div class="MyMoeinListCat_Div">
        <span class="MyMoeinListCat_Span">ریشه</span>

      </div>

      <app-Protocol17025Cat_Co_Check
        (On_Change_Action)="OnGet_Change_Action($event)"
        [inner_17025_Cat]="DataList_Protocol17025Cat">

      </app-Protocol17025Cat_Co_Check>

    </li>
  </ul>
</div>
